import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, FileCheckIcon, UsersIcon } from 'lucide-react';
export function SolutionSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -30
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="w-full py-20 px-4 bg-gradient-to-b from-navy-light to-navy" data-id="element-233">
      <div className="max-w-6xl mx-auto" data-id="element-234">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-235">
          <motion.div variants={itemVariants} className="text-center mb-16" data-id="element-236">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black mb-6" data-id="element-237">
              <span className="text-gold-metallic" data-id="element-238">
                Sistema de Optimización Crediticia
              </span>
            </h2>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-239">
              Un plan diseñado para{' '}
              <strong className="text-gold-light" data-id="element-240">personas comunes</strong>, no
              para expertos en finanzas.
            </p>
          </motion.div>

          <div className="space-y-8" data-id="element-241">
            {/* Mes 1 */}
            <motion.div variants={itemVariants} className="bg-navy-lighter border-2 border-gold/30 rounded-2xl p-8 md:p-10 hover:border-gold/50 transition-colors" data-id="element-242">
              <div className="flex flex-col md:flex-row items-start md:items-center gap-6" data-id="element-243">
                <div className="flex-shrink-0" data-id="element-244">
                  <div className="w-20 h-20 bg-gradient-to-br from-gold-light to-gold rounded-full flex items-center justify-center" data-id="element-245">
                    <CalendarIcon className="w-10 h-10 text-navy" aria-hidden="true" data-id="element-246" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-247">
                  <div className="flex items-center gap-3 mb-3" data-id="element-248">
                    <span className="text-5xl md:text-6xl font-heading font-black text-gold-metallic" data-id="element-249">
                      01
                    </span>
                    <h3 className="text-2xl md:text-3xl font-heading font-bold text-white" data-id="element-250">
                      Mes 1
                    </h3>
                  </div>
                  <p className="text-xl md:text-2xl text-gold-light font-semibold mb-2" data-id="element-251">
                    📅 Pago Estratégico Antes de la Fecha de Corte
                  </p>
                  <p className="text-lg text-gray-300" data-id="element-252">
                    Aprenderás{' '}
                    <strong className="text-gold-light" data-id="element-253">
                      cómo funciona el ciclo de facturación
                    </strong>
                    , cuándo es tu fecha de corte, y cómo programar tus pagos de
                    forma inteligente para optimizar tu perfil crediticio.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Mes 2 */}
            <motion.div variants={itemVariants} className="bg-navy-lighter border-2 border-gold/30 rounded-2xl p-8 md:p-10 hover:border-gold/50 transition-colors" data-id="element-254">
              <div className="flex flex-col md:flex-row items-start md:items-center gap-6" data-id="element-255">
                <div className="flex-shrink-0" data-id="element-256">
                  <div className="w-20 h-20 bg-gradient-to-br from-gold-light to-gold rounded-full flex items-center justify-center" data-id="element-257">
                    <FileCheckIcon className="w-10 h-10 text-navy" aria-hidden="true" data-id="element-258" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-259">
                  <div className="flex items-center gap-3 mb-3" data-id="element-260">
                    <span className="text-5xl md:text-6xl font-heading font-black text-gold-metallic" data-id="element-261">
                      02
                    </span>
                    <h3 className="text-2xl md:text-3xl font-heading font-bold text-white" data-id="element-262">
                      Mes 2
                    </h3>
                  </div>
                  <p className="text-xl md:text-2xl text-gold-light font-semibold mb-2" data-id="element-263">
                    ✍️ Disputa Errores de Forma Estructurada y 100% Legal
                  </p>
                  <p className="text-lg text-gray-300" data-id="element-264">
                    <strong className="text-gold-light" data-id="element-265">
                      Sin palabras complicadas
                    </strong>
                    . Te damos las plantillas exactas y el proceso paso a paso
                    para disputar errores en tu reporte.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Mes 3 */}
            <motion.div variants={itemVariants} className="bg-navy-lighter border-2 border-gold/30 rounded-2xl p-8 md:p-10 hover:border-gold/50 transition-colors" data-id="element-266">
              <div className="flex flex-col md:flex-row items-start md:items-center gap-6" data-id="element-267">
                <div className="flex-shrink-0" data-id="element-268">
                  <div className="w-20 h-20 bg-gradient-to-br from-gold-light to-gold rounded-full flex items-center justify-center" data-id="element-269">
                    <UsersIcon className="w-10 h-10 text-navy" aria-hidden="true" data-id="element-270" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-271">
                  <div className="flex items-center gap-3 mb-3" data-id="element-272">
                    <span className="text-5xl md:text-6xl font-heading font-black text-gold-metallic" data-id="element-273">
                      03
                    </span>
                    <h3 className="text-2xl md:text-3xl font-heading font-bold text-white" data-id="element-274">
                      Mes 3
                    </h3>
                  </div>
                  <p className="text-xl md:text-2xl text-gold-light font-semibold mb-2" data-id="element-275">
                    Cómo utilizar correctamente la estrategia de usuario
                    autorizado
                  </p>
                  <p className="text-lg text-gray-300" data-id="element-276">
                    Descubre{' '}
                    <strong className="text-gold-light" data-id="element-277">paso a paso</strong>{' '}
                    cómo aplicar esta estrategia de forma correcta y cómo puede
                    impactar tu historial crediticio.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}